/* import __COLOCATED_TEMPLATE__ from './content-part-first.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();